module.exports = __webpack_public_path__ + "img/under.a2e854e6.png";